import { toast } from 'react-toastify';
import RecepcionarTypes from './types';
import 'react-toastify/dist/ReactToastify.css';

import { MESSAGES } from '../../../../../constants/messages';
import actions from 'redux-form/lib/actions';

const INITIAL_STATE = {
  protocolo: '',
  protocolo_data: {},
  dossies: [],
  loading: false,
  error: false,
  tipoEnvio: '',
  numeroInvalidoProtocolo: false,
  modalProtocoloRecepcionado: false,
  modalProtocoloExcluido: false,
  redirecionarParaPaginaProtocoloRecepcaoContrato: false,
};

const statusPendente = 'PENDENTE';
const statusParcial = 'PARCIAL';
const statusRecepcionado = 'Recepcionado Total';

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RecepcionarTypes.CLEAR:
      return {
        ...state,
        protocolo: '',
        idProtocolo: '',
        protocolo_data: {},
        totalContratos: 0,
        numeroInvalidoProtocolo: false,
        modalProtocoloRecepcionado: false,
        modalProtocoloExcluido: false,
        redirecionarParaPaginaProtocoloRecepcaoContrato: false,
        descricaoStatus: '',
        etiqueta: '',
        dataGeracao: '',
      };

    case RecepcionarTypes.SEARCH_REQUEST:
      const numeroInvalidoProtocolo = action.payload === '';
      return {
        ...state,
        protocolo: action.payload,
        numeroInvalidoProtocolo,
        loading: true,
      };

    case RecepcionarTypes.SEARCH_FAILURE:
      toast.error(MESSAGES.DEFAULT_ERROR_MESSAGE);
      return { ...state, loading: false, error: true };

    case RecepcionarTypes.SEARCH_SUCCESS:
      const dados_protocolo = {};
      let modalProtocoloRecepcionado = false;
      const modalProtocoloExcluido = false;
      let redirecionarParaPaginaProtocoloRecepcaoContrato = false;
      let protocolo = '';
      let idProtocolo = '';
      let descricaoStatus = '';
      let totalContratos = 0;
      let tipoEnvio = '';
      let etiqueta = '';
      let dataGeracao = '';
      if (action.payload.length > 0) {
        const status = action.payload[0].DescricaoStatus === statusRecepcionado;
        if (!status) {
          idProtocolo = action.payload[0].IdProtocolo;
          descricaoStatus = action.payload[0].DescricaoStatus;
          protocolo = action.payload[0].Protocolo;
          totalContratos = action.payload[0].TotalContratos;
          redirecionarParaPaginaProtocoloRecepcaoContrato = true;
          tipoEnvio = action.payload[0].TipoEnvio;
          etiqueta = action.payload[0].Etiqueta;
          dataGeracao = action.payload[0].DataGeracao;
        } else {
          modalProtocoloRecepcionado = true;
          redirecionarParaPaginaProtocoloRecepcaoContrato = false;
        }
      } else {
        redirecionarParaPaginaProtocoloRecepcaoContrato = false;
      }

      return {
        ...state,
        numeroInvalidoProtocolo: !action.payload.length,
        modalProtocoloRecepcionado,
        idProtocolo,
        protocolo,
        dataGeracao,
        totalContratos,
        modalProtocoloExcluido,
        redirecionarParaPaginaProtocoloRecepcaoContrato,
        protocolo_data: dados_protocolo,
        descricaoStatus,
        tipoEnvio,
        etiqueta,
        loading: false,
        error: false,
      };

    default:
      return state;
  }
};
